// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WUN1","content":"styles_content__24n8m","row":"styles_row__2MFNW","footer":"styles_footer__25HNK","phraseLength":"styles_phraseLength__2_a9I"};